export const get_translation = lang => {
    if (lang == 'fa'){
        return farsi_lang
    }

    return default_lang
}

const app_name = 'Homa'

const default_lang = {
    navbar_app_name: `${app_name}`,
    navbar_new_msg: 'New',
    navbar_msg_list: 'Messages',
    ws_msg_01: `Hi, I'm happy you came 👋! I’m ${app_name} - you're intelligent, helpful assistant who you can ask about anything from history, to food, to how to write a business plan even. What would you like to ask?`
}

const farsi_lang = {
    navbar_app_name: 'هما',
    navbar_new_msg: 'جدید',
    navbar_msg_list: 'پیام‌ها',
    settings_chat_pdf:"دانلود گفتگو کامل به صورت PDF"    ,
    settings_chat_doc:'',
    settings_close:'بستن تنظیمات',
    settings_title:'تنظیمات',
    ws_msg_01: "سلام، خوشحالم که آمدید 👋! من هما هستم - من یک دستیار هوشمند و مفید هستم که می‌توانید درباره هر موضوعی از تاریخ، غذا، حتی نوشتن یک طرح کسب و کار سؤال کنید. چه میخواهید بپرسید؟",
    ws_msg_01_cat_food:'غذا',
    ws_msg_01_cat_hist:'تاریخ',
    ws_msg_01_cat_bus:'کسب و کار',
    ws_msg_01_cat_health:'سلامت روح و جسم',
    ws_msg_01_cat_insta:'اینستاگرام'
}